import React, { createContext, useContext, useState, useRef } from 'react';

const ShimmerContext = createContext(null);

export const ShimmerProvider = ({ children }) => {
    const [activeShimmer, setActiveShimmer] = useState(null);
    const shimmerTimeout = useRef(null);

    const clearShimmerTimeout = () => {
        if (shimmerTimeout.current) {
            clearTimeout(shimmerTimeout.current);
            shimmerTimeout.current = null;
        }
    };

    const highlightElement = (elementId, duration = 0) => {
        clearShimmerTimeout();
        setActiveShimmer(elementId);

        // Only set timeout if duration is positive
        if (duration > 0) {
            shimmerTimeout.current = setTimeout(() => {
                setActiveShimmer(null);
            }, duration);
        }
    };

    const clearShimmer = () => {
        clearShimmerTimeout();
        setActiveShimmer(null);
    };

    return (
        <ShimmerContext.Provider value={{ activeShimmer, highlightElement, clearShimmer }}>
            {children}
        </ShimmerContext.Provider>
    );
};

export const useShimmer = () => {
    const context = useContext(ShimmerContext);
    if (!context) {
        throw new Error('useShimmer must be used within a ShimmerProvider');
    }
    return context;
};